import { render, staticRenderFns } from "./detail-stock-return-by-product.vue?vue&type=template&id=79c18ce2&"
import script from "./detail-stock-return-by-product.vue?vue&type=script&lang=js&"
export * from "./detail-stock-return-by-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports